import { object, string, number, array, ref } from 'yup';
import HttpStatus from 'http-status-codes';

// TODO: need to handle this err type properly
export const SchemaError = {
  [HttpStatus.BAD_REQUEST]: {
    server: 'Some Err occured'
  }
};

export default object().shape({
  minSpend: number().nullable(true),
  usagePerUser: number()
    .required('Uses Per User is required')
    .nullable(true),
  usageTotal: number()
    .required('Please provide 0 to indicate unlimited ')
    .nullable(true),
  serviceType: array().nullable(true),
  type: array()
    .nullable(true)
    .test(
      'valid-reucrring',
      'Recurring cleans are not supported for move out service',
      function(value) {
        const serviceTypes = this.resolve(ref('serviceType'));
        if (
          (value || []).includes('recurring') &&
          (serviceTypes || []).includes('move-out')
        ) {
          return false;
        }

        return true;
      }
    ),
  discountType: string().required('Discount Type is required'),
  amount: number()
    .required('Discount is required')
    .when('discountType', {
      is: '%',
      then: number()
        .integer()
        .min(1, 'Discount percentage must be grater than 0')
        .max(100, 'Discount percentage should not be greater than 100')
    })
    .nullable(true),
  status: string().required('Status is required'),
  aliases: array().required('Alias is required'),
  title: string().required('Coupon Title is required'),
  days: array().nullable(true),
  notes: string().nullable(true)
});
